import ScreenView from '~/components/layout/ScreenView'
import { ScrollView } from '~/components/ScrollView'
import { MessagePreviewsView } from '~/components/user/realtors/MessagePreviewsView'

export default function MessagePreviewsPage() {
  return (
    <ScreenView className="justify-start">
      <ScrollView
        className="flex-1 rounded-content"
        offsetTrackHeight
        contentContainerClassName="pb-6">
        <MessagePreviewsView />
      </ScrollView>
    </ScreenView>
  )
}
